export class CybersecurityGraph {
    init() {
        var self = {
            selectors: {
                pageSection: "#cybersecurityGraph",
                graph: "#cybersecurityGraph .cybersecurity-graph__img",
                tooltipSelectors: '#cybersecurityGraph .cybersecurity-graph__img g[id^="_"], #cybersecurityGraph .cybersecurity-graph__img .tooltip-box',
                popupSelectors: "#cybersecurityGraph .cybersecurity-graph__img .active-popup",
                jsonPopupData: {},
                jsonTooltipData: {},
                popup: "#cybersecurityGraphPopup .cybersecurity-graph__popup",
                popupOverlay: ".cybersecurity-graph__popup-overlay",
                closePopupBtn: ".cybersecurity-graph__popup-close",
                popupElements: {
                    title: ".cybersecurity-graph__popup-title",
                    description: ".cybersecurity-graph__popup-description",
                    stats_tam_2026: ".cybersecurity-graph__popup-stats_tam_2026",
                    stats_5y_cagr: ".cybersecurity-graph__popup-stats_5y_cagr",
                    picks: ".cybersecurity-graph__popup-picks",
                    articles: ".cybersecurity-graph__popup-articles",
                    button: ".cybersecurity-graph__popup-button",
                },
                pageLoader: '#cybersecurityLoader',
                mainBoxes: [
                    '#Threat_intelligence_group',
                    '#Application_security_group',
                    '#Endpoint_security_group',
                    '#Network_security_group',
                    '#Cloud_group',
                ]
            },
            initTooltip() {
                // Add tooltip attributes (arrows)
                $.each(self.selectors.jsonTooltipData, (key, tooltipData) => {
                    if (tooltipData.hasOwnProperty('text') && tooltipData.text.length > 0) {
                        $('#' + tooltipData.id)
                            .attr('title', tooltipData.text)
                            .attr('data-toggle', 'tooltip')
                            .attr('data-theme', 'dark');
                    }

                    if (tooltipData.hasOwnProperty('parent_id')) {
                        $('#' + tooltipData.id)
                            .addClass('has-parent')
                            .attr('data-parent', tooltipData.parent_id);
                    }
                });

                var $div = $('<div/>').addClass('cybersecurity-graph__tooltip').appendTo('body');
                var $tooltipData;

                $(self.selectors.tooltipSelectors)
                    .mousemove(function (e) {
                        $div.css({
                            top: e.pageY + 10 + 'px',
                            left: self.calculateTooltipLocation($div.outerWidth(), e.pageX) + 'px'
                        }).attr(
                            'data-theme',
                            $(this).attr('data-theme')
                        );
                    })
                    .hover(
                        function () {
                            $tooltipData = $(this).attr('title');

                            if (typeof $tooltipData === 'undefined' || $tooltipData.length <= 0) {
                                return;
                            }

                            $div.html($tooltipData).fadeIn();
                        },
                        function () {
                            $div.hide();
                        }
                    );

                $div.mouseover(function (e) {
                    $(this).hide();
                });
            },
            initPopup() {
                var $popup = $(self.selectors.popup);

                $.each(self.selectors.jsonPopupData, (key, popupData) => {
                    $('#' + popupData.id).addClass('active-popup');

                    // Add tooltip attributes (boxes)
                    if (self.checkPropertyExists(popupData, "description") && self.checkPropertyExists(popupData, "theme") && popupData.theme === 'light') {
                        $('#' + popupData.id).addClass('tooltip-box')
                            .attr('title', popupData.description)
                            .attr('data-toggle', 'tooltip')
                            .attr('data-theme', 'light');
                    }

                    if (popupData.hasOwnProperty("parent_id")) {
                        $('#' + popupData.id).addClass('has-parent').attr('data-parent', popupData.parent_id);
                    }
                });

                $(self.selectors.popupSelectors)
                    .click(function (e) {
                        var $popupData = self.getPopupData($(this).attr('id'));

                        if (typeof $popupData === 'undefined') {
                            return;
                        }

                        if (!$popupData.hasOwnProperty('stats_tam_2026') && !$popupData.hasOwnProperty('stats_5y_cagr')) {
                            $popup.find('.cybersecurity-graph__popup-stats').hide()
                        } else {
                            $popup.find('.cybersecurity-graph__popup-stats').show()
                        }

                        $.when(
                            $.each(self.selectors.popupElements, (key, elementSelector) => {
                                if ($popupData.hasOwnProperty(key) && $popupData[key].length > 0) {
                                    $popup.find(elementSelector).show().find('.content').html($popupData[key]);
                                    return;
                                }

                                $popup.find(elementSelector).hide()
                            })
                        )
                        .then(function () {
                            $popup.css({
                                top: e.pageY + 10 + 'px',
                                left: self.calculatePopupLocation($popup.outerWidth(), e.pageX) + 'px'
                            }).attr(
                                "data-theme",
                                $popupData.theme
                            ).fadeIn();

                            $(self.selectors.popupOverlay).fadeIn();
                            $('.cybersecurity-graph__tooltip').hide();
                        });

                    });

                // Close popup on click on the button
                $(self.selectors.closePopupBtn).click(function (e) {
                    self.closePopup()
                });

                // Close popup on click outsite popup
                $('.cybersecurity-graph__popup-overlay').mouseup(function (e) {
                    var $popup = $(self.selectors.popup);

                    if (!$popup.is(e.target) && $popup.has(e.target).length === 0) {
                        self.closePopup()
                    }
                });
            },
            closePopup() {
                var $popup = $(self.selectors.popup);

                $popup.fadeOut(function () {
                    $.each(self.selectors.popupElements, (key, elementSelector) => {
                        $popup.find(elementSelector).find('.content').html("");
                    });
                })

                $(self.selectors.popupOverlay).fadeOut('slow');
            },
            calculatePopupLocation(popupWidth, pageX) {
                var r = $(window).width() - pageX;
                var v = 0;
                var h = (popupWidth / 2);

                if (r < h) {
                    v = (-1 * (h - r)) - 20;
                }

                if (pageX < h) {
                    v = (h - pageX) + 20;
                }

                return pageX - h + v;
            },
            calculateTooltipLocation(width, pageX) {
                var r = $(window).width() - pageX;

                return r > width
                    ? pageX + 5
                    : pageX - width - 5;
            },
            parsePopupData($data) {
                var popupsArr = [];

                $.each($data, (key, element) => {
                    popupsArr.push( self.parse(element) )
                });

                return popupsArr;
            },
            parse($popupData) {
                var $data = {};

                $data.id = $popupData.id;
                $data.theme = $popupData.theme;

                if (self.checkPropertyExists($popupData, 'parent_id')) {
                    $data.parent_id = $popupData.parent_id;
                }

                if (self.checkPropertyExists($popupData, 'name')) {
                    $data.title = $popupData.name;
                }

                if (self.checkPropertyExists($popupData, 'shortname')) {
                    $data.title += '<br/><span class="shortname">(' + $popupData.shortname + ')</span>';
                }

                if (self.checkPropertyExists($popupData, 'description')) {
                    $data.description = $popupData.description;
                }

                if (self.checkPropertyExists($popupData, 'stats_tam_2026')) {
                    $data.stats_tam_2026 = Math.round($popupData.stats_tam_2026) + ' ';
                }

                if (self.checkPropertyExists($popupData, 'stats_5y_cagr')) {
                    $data.stats_5y_cagr = Math.round($popupData.stats_5y_cagr) + '%';
                }

                if (self.checkPropertyExists($popupData, 'picks')) {
                    $data.picks = $popupData.picks.join(', ');
                }

                if (self.checkPropertyExists($popupData, 'articles')) {
                    $data.articles = self.getPopupArticles($popupData.articles);
                    $data.button = self.getPopupButton($popupData.articles);
                }

                return $data;
            },
            checkPropertyExists($object, $property) {
                return $object.hasOwnProperty($property) && $object[$property].length > 0;
            },
            getPopupArticles($articles) {
                var $result = [];

                $.each($articles, (key, article) => {
                    if (self.checkPropertyExists(article, "title") && self.checkPropertyExists(article, "url") && ! article.hasOwnProperty("is_button")) {
                        var $html = $("<li/>").html(
                            $("<a />", {
                                title: article.title,
                                href: article.url,
                                text: article.title
                            }).attr('target', '_blank')
                        );
                        $result.push($html);
                    }
                });

                return $result;
            },
            getPopupButton($articles) {
                var article = $articles.find(x => x.is_button === true);

                if (typeof article === 'undefined') {
                    return;
                }

                return $("<a />", {
                    title: article.title,
                    href: article.url,
                    text: "Discover the topic"
                }).attr('target', '_blank');
            },
            loadJson() {
                $(self.selectors.pageLoader).show();

                fetch("./cybersecurity-graph-data.json")
                    .then(response => {
                        return response.json();
                    })
                    .then(json => {
                        self.selectors.jsonPopupData = self.parsePopupData(json.popups);
                        self.selectors.jsonTooltipData = json.tooltips;
                    })
                    .then(() => {
                        self.initPopup()
                    })
                    .then(() => {
                        self.initTooltip()
                    })
                    .then(() => {
                        self.initHover()
                    })
                    .then(() => {
                        $(self.selectors.pageLoader).hide();
                    });
            },
            getPopupData($id) {
                return self.selectors.jsonPopupData.find((o) => o.id == $id)
            },
            initHover() {
                $('.cybersecurity-graph__hover-element').css('transition', 'opacity 0.2s ease-in-out');
                $.each(self.selectors.mainBoxes, (key, elementSelector) => {
                    $(elementSelector + '_HOVER').css('transition', 'opacity 0.3s ease-in-out');
                });

                $("#cybersecurity_interactive_chart #Original g").hover(
                    function () {
                        let $id = $(this).attr('id');
                        self.setHoverElementOpacity($id, 1);
                        self.setParentElementOpacity($id, 1);
                    }, function () {
                        let $id = $(this).attr('id');
                        self.setHoverElementOpacity($id, 0);
                        self.setParentElementOpacity($id, 0);
                    }
                );
            },
            setHoverElementOpacity($id, $opacity) {
                let hoverElem = $("#" + $id + "_HOVER");

                if (hoverElem.length) {
                    hoverElem.css('opacity', $opacity);
                }
            },
            setParentElementOpacity($id, $opacity) {
                let parentsIds;

                if (typeof $id === 'undefined') {
                    return;
                }

                if ($id.startsWith("_")) {
                    parentsIds = $('#' + $id).attr('data-parent');
                } else {
                    parentsIds = $('#' + $id + '> .has-parent').attr('data-parent');
                }

                self.setOpacityOnParents(parentsIds, $opacity);
            },
            setOpacityOnParents($parentsIds, $opacity) {
                if (typeof $parentsIds !== 'string') {
                    return;
                }

                let parentsArr = $parentsIds.split(',');

                $.each(parentsArr, (key, parentId) => {
                    let parentElem = $(parentId + "_HOVER");

                    if (typeof parentElem !== 'undefined') {
                        parentElem.css('opacity', $opacity);
                    }
                })
            },
        };

        if ($(self.selectors.pageSection).length > 0 && typeof $(self.selectors.pageSection) !== 'undefined') {
            self.loadJson();
        }
    }
}
